import { DiscoveryItemClickEvent } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
export const trackCourseClickEvent = (course, index, backendSource, uiRegion) => {
  var _ref, _course$badges, _ref2, _course$frontendTrack, _course$tracking_id$t, _course$tracking_id;
  const badgeFamilies = course.visibleBadgeFamilies ? course.visibleBadgeFamilies : (_ref = (_course$badges = course.badges) === null || _course$badges === void 0 ? void 0 : _course$badges.map(b => b.badge_family)) !== null && _ref !== void 0 ? _ref : null;
  const trackingId = (_ref2 = (_course$frontendTrack = course.frontendTrackingId) !== null && _course$frontendTrack !== void 0 ? _course$frontendTrack : course.tracking_id) !== null && _ref2 !== void 0 ? _ref2 : '';
  Tracker.publishEvent(new DiscoveryItemClickEvent({
    id: course.id,
    type: 'course',
    trackingId,
    serveTrackingId: (_course$tracking_id$t = (_course$tracking_id = course.tracking_id) === null || _course$tracking_id === void 0 ? void 0 : _course$tracking_id.toString()) !== null && _course$tracking_id$t !== void 0 ? _course$tracking_id$t : '',
    backendSource,
    position: index,
    badgeFamilies,
    uiRegion
  }));
};
//# sourceMappingURL=course-card-tracking.js.map